import { Box, Space, Stack, Text } from '@mantine/core';
import { FC, memo } from 'react';
import { Button } from 'src/components/Button';
import { Modal } from 'src/components/Modal';

import { useDeleteTheme } from './use-delete-theme';

export const DeleteThemeModal: FC = memo(() => {
  const { handleConfirm, handleClose, isPending, open } = useDeleteTheme();

  return (
    <Modal
      opened={open}
      onClose={handleClose}
      centered
      size="lg"
      title=""
      closeOnClickOutside={!isPending}
      closeOnEscape={!isPending}
      withCloseButton={!isPending}
    >
      <Stack gap="md" align="center">
        <Text size="md" c="var(--color-white-placeholder)" ta="center">
          Are you sure you want to delete this theme?
        </Text>

        <Text size="sm" c="var(--color-white-placeholder)" ta="center">
          This action cannot be undone and will permanently remove the theme.
        </Text>

        <Space h="lg" />

        <Box display="flex" style={{ gap: '36px' }}>
          <Button
            variant="outline"
            round
            size="md"
            onClick={handleClose}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            round
            size="md"
            onClick={handleConfirm}
            loading={isPending}
            disabled={isPending}
          >
            Delete
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
});

DeleteThemeModal.displayName = 'DeleteThemeModal';
